exports = module.exports = require("../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.vt99kmDCZLQTaVOPal9-D{border-radius:1.14286rem}.vt99kmDCZLQTaVOPal9-D img{width:2rem;height:2rem;margin-right:1.14286rem}\n", ""]);

// exports
exports.locals = {
	"facilitateDelivery": "vt99kmDCZLQTaVOPal9-D"
};